import React from "react";
import { SingleCollection } from "../components/SingleCollection/SingleCollection";

export const CollectionPage = () => {
  return <SingleCollection />;
};
